import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const getSupplies = async () => { //obtener informacion de ambientes
  try {
    const { data } = await _axios.get("/api/supplies?limit=0");
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getSuppliesByPage = async (page, sortProp, queryObj) => { //obtener informacion de ambientes

  const stringifiedQuery = Object.keys(queryObj).length
    ? qs.stringify({ where: queryObj })
    : "";

  try {
    const { data } = await _axios.get(`/api/supplies?page=${page}` +
      (stringifiedQuery ? `&${stringifiedQuery}` : "") +
      (sortProp ? `&sort=${sortProp}` : ""));
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateSupplyProps = async (supplyId, updatedProps) => {
  try {
    const { data } = await _axios.patch(`/api/supplies/${supplyId}`, { ...updatedProps });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createSupplie = async (supplieProps) => {
  try {
    const { data } = await _axios.post("/api/supplies", supplieProps);
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadSupplieImage = async (props) => {
  try {
    const formData = new FormData();
    formData.append("alt", props.alt);
    formData.append("file", props.file);

    const { data } = await _axios.post(`/api/supplyPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadSupplieFile = async (props) => {
  try {
    const formData = new FormData();
    formData.append("file", props.file);

    const { data } = await _axios.post(`/api/supplyFiles`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteSupply = async (supplyId, supplyPhotoId, supplyFileId) => {
  try {
    if (supplyPhotoId) await deleteSupplyImage(supplyPhotoId);
    if (supplyFileId) await deleteSupplyFile(supplyFileId);
    const { data } = await _axios.delete(`/api/supplies/${supplyId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteSupplyImage = async (imageId) => {
  try {
    const { data } = await _axios.delete(`/api/supplyPhotos/${imageId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteSupplyFile = async (fileId) => {
  try {
    const { data } = await _axios.delete(`/api/supplyFiles/${fileId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateSupplyQuantity = async (supplyId, quantity) => {
  try {
    const { data } = await _axios.patch(`/api/modifyQuantity/${supplyId}`, { quantity: quantity });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

// export const changeSupplieFile = async (props) => { pendiente
//   try {
//     const formData = new FormData();
//     formData.append("file", props.file);

//     const { data } = await _axios.post(`/api/supplieFiles`, formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       }
//     });
//     return data.doc;
//   }
//   catch (err) {
//     IS_LOCAL_ENV && console.error(err);
//   }
// }
